module.exports = __webpack_public_path__ + "static/sol-k12-section-1-img-e73ca8d50896640716bd6a7a6e900cf7.jpg";